import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';

export const higherLowerResultOverlayStyles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.78)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    width: '100%',
    backgroundColor: WARMUP_COLORS.surface,
    borderRadius: 20,
    padding: 24,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: WARMUP_COLORS.border,
  },
  emoji: { fontSize: 40, lineHeight: 46 },
  title: {
    fontSize: 22,
    fontWeight: '800',
    color: WARMUP_COLORS.text,
    textAlign: 'center',
    letterSpacing: -0.2,
    marginTop: 4,
  },
  scoreRow: { flexDirection: 'row', alignItems: 'baseline', gap: 7, marginVertical: 6 },
  score: { fontSize: 44, fontWeight: '800', color: WARMUP_COLORS.green, fontVariant: ['tabular-nums'] },
  scoreLabel: { fontSize: 14, fontWeight: '700', color: WARMUP_COLORS.textDim },
  sub: {
    fontSize: 13,
    color: WARMUP_COLORS.textDim,
    textAlign: 'center',
    fontWeight: '500',
    marginTop: 2,
    marginBottom: 6,
  },
  subStrong: { color: WARMUP_COLORS.text, fontWeight: '800' },
  primaryButton: {
    width: '100%',
    backgroundColor: WARMUP_COLORS.purple,
    borderRadius: 12,
    paddingVertical: 14,
    minHeight: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 14,
  },
  primaryText: { fontSize: 16, fontWeight: '800', color: WARMUP_COLORS.textOnBright },
  secondaryButton: {
    width: '100%',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#374151',
    paddingVertical: 13,
    minHeight: 48,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8,
  },
  secondaryText: { fontSize: 15, fontWeight: '700', color: WARMUP_COLORS.text },
  pressed: { opacity: 0.85 },
});
